import { filterTemplates } from 'common/api/templates';

import {
    FETCH_FILTER_TEMPLATES,
    FETCH_FILTER_TEMPLATES_FAILURE,
    FETCH_FILTER_TEMPLATES_SUCCESS,
} from '../actionTypes';
import { templatesActions } from '../reducer';

export default (filterData) => (dispatch) => {
    dispatch(templatesActions[FETCH_FILTER_TEMPLATES]());

    const {
        orderBy,
        page = 0,
        pageSize,
        searchText,
        sortBy,
        status,
    } = filterData;

    filterTemplates({
        orderBy,
        page: page + 1,
        perPage: pageSize,
        searchText,
        sortBy,
        status,
    })
        .then((response) =>
            dispatch(
                templatesActions[FETCH_FILTER_TEMPLATES_SUCCESS](response.data),
            ),
        )
        .catch((error) =>
            dispatch(
                templatesActions[FETCH_FILTER_TEMPLATES_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
